<template>
  <Transition :name="`fade-${origin}`">
    <slot />
  </Transition>
</template>

<script setup lang="ts">
defineProps({
  origin: {
    type: String as PropType<'top' | 'bottom'>,
    default: 'top',
  },
});
</script>

<style>
.fade-top-enter-active,
.fade-top-leave-active,
.fade-bottom-enter-active,
.fade-bottom-leave-active {
  @apply tw-transition;
}

.fade-top-enter-from,
.fade-top-leave-to {
  @apply tw-opacity-0 -tw-translate-y-4;
}

.fade-bottom-enter-from,
.fade-bottom-leave-to {
  @apply tw-opacity-0 tw-translate-y-4;
}
</style>
